import React, { useState } from "react";
import "../Home/Home.css";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { FaLocationDot, FaRegCirclePlay, FaCarOn } from "react-icons/fa6";
import { MdSupportAgent } from "react-icons/md";
import { GiReceiveMoney } from "react-icons/gi";
import emailjs from "emailjs-com";

const Home = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [enquiryModalIsOpen, setEnquiryModalIsOpen] = useState(false);
  const [brochureModalIsOpen, setBrochureModalIsOpen] = useState(false);
  const [detailsModalIsOpen, setDetailsModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const openModal = (image) => {
    setSelectedImage(image);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedImage(null);
  };

  const openEnquiryModal = () => {
    setEnquiryModalIsOpen(true);
  };

  const closeEnquiryModal = () => {
    setEnquiryModalIsOpen(false);
  };

  const openBrochureModal = () => {
    setBrochureModalIsOpen(true);
  };

  const closeBrochureModal = () => {
    setBrochureModalIsOpen(false);
  };

  const openDetailsModal = () => {
    setDetailsModalIsOpen(true);
  };

  const closeDetailsModal = () => {
    setDetailsModalIsOpen(false);
  };

  const validateName = (value) => {
    if (!/^[a-zA-Z\s]*$/.test(value)) {
      setNameError("Name can only contain alphabets");
    } else {
      setNameError("");
    }
    setName(value);
  };

  const validateEmail = (value) => {
    if (!/\S+@\S+\.\S+/.test(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
    setEmail(value);
  };

  const validateMobile = (value) => {
    if (!/^\d{10}$/.test(value)) {
      setMobileError("Mobile number must be 10 digits");
    } else {
      setMobileError("");
    }
    setMobile(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nameError && !emailError && !mobileError) {
      setIsSubmitting(true);

      const templateParams = {
        name,
        email,
        mobile,
      };

      emailjs
        .send(
          "service_v4vfeg",
          "template_0xkej3k",
          templateParams,
          "qfKVeiD_DgSTnVKYW",
        )
        .then((response) => {
          Swal.fire({
            title: "Form Submitted Successfully!",
            text: "Thanks you for expressing interest on our website our expert will get in touch with you shortly",
            imageUrl: "ty2.webp",
            imageWidth: 400,
            imageHeight: 200,
            imageAlt: "Custom image",
          });
          setIsSubmitting(false);
          closeEnquiryModal();
        })
        .catch((error) => {
          Swal.fire({
            title: "Oops!",
            text: "There was an error submitting the form. Please try again.",
            icon: "error",
          });
          setIsSubmitting(false);
        });
    } else {
      alert("Please fix the errors in the form");
    }
  };

  const images = [
    "g1.webp",
    "g2.webp",
    "g3.webp",
    "g4.webp",
    "g5.webp",
    "g6.webp",
  ];

  return (
    <>
      <section id="home" className="slider-section">
        <div
          id="carouselExampleIndicators2"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="2000"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators2"
              data-bs-slide-to={0}
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            />
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators2"
              data-bs-slide-to={1}
              aria-label="Slide 2"
            />
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="/i1.webp" className="image-slider" alt="banner1" />
            </div>
            <div className="carousel-item">
              <img src="/i2.webp" className="image-slider" alt="banner2" />
            </div>
          </div>
          <button
            className="carousel-control-prev1"
            type="button"
            data-bs-target="#carouselExampleIndicators2"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next2"
            type="button"
            data-bs-target="#carouselExampleIndicators2"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Next</span>
          </button>
          <div className="carousel-overlay">
            <h2>AIGIN ROYAL</h2>
            <p>At Sector 1, Greater Noida West</p>
            <p className="group-p">By AIGIN Group</p>
            <div className="offer-list">
              <div className="offer-div">
                <ul>
                  <li>✓ Land Area : 4.3 Acres </li>
                  <li>✓ Total Towers : 8</li>
                  <li>✓ No. of Units: 755</li>
                  <li>✓ Total Floors : 20</li>
                  <li>✓ SBI Approved Project</li>
                  <li>✓ ISI copper wiring PVC</li>
                </ul>
              </div>
            </div>
            <p className="price-info">
              Premium 2 & 3 BHK Apartments
              <br />
              Starting Price - On Request*
            </p>
            <button className="button-13" onClick={openEnquiryModal}>
              Enquire Now
            </button>
          </div>
        </div>
      </section>

      <Modal
        isOpen={enquiryModalIsOpen}
        onRequestClose={closeEnquiryModal}
        contentLabel="Enquiry Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeEnquiryModal}>
          ×
        </button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back </p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">AIGIN ROYAL</h2>
            <p className="modal-sub-heading">At Sector 1, Greater Noida West</p>
            <form className="modal-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => validateName(e.target.value)}
                  required
                />
                {nameError && <p className="error">{nameError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => validateEmail(e.target.value)}
                  required
                />
                {emailError && <p className="error">{emailError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={mobile}
                  onChange={(e) => validateMobile(e.target.value)}
                  required
                />
                {mobileError && <p className="error">{mobileError}</p>}
              </div>
              <div className="butt-f">
                <button
                  className="submit-button-f"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Enquire Now"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <section id="overview" className="overview-section">
        <div className="all-overview">
          <h1 className="head">Summary</h1>
          <div className="container">
            <div className="div-cont">
              <h2 className="section-title">AIGIN Royal</h2>
              <p className="location">At Sector 1, Greater Noida West</p>
              <p id="br" className="description">
                AIGIN Royal in Sector 1, Greater Noida West, is a ready-to-move
                housing society designed to blend comfort, convenience, and
                style. Offering well-planned 2BHK and 3BHK apartments, the
                project is spread across 4.3 acres with 8 towers, 20 floors
                each, and a total of 755 units. SBI Approved, the project gives
                homebuyers additional trust and reliability. Families have
                already started moving in, making it a vibrant and growing
                community. With its excellent connectivity to D.S. International
                School, Yatharth Super Speciality Hospital, and the FNG
                Expressway, AIGIN Royal offers the right balance of lifestyle
                and affordability in one of Greater Noida’s most promising
                locations.
              </p>

              <div className="overview-button" id="brochure">
                <button className="button-34" onClick={openBrochureModal}>
                  Download Brochure
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="about-overview">
          <div className="containerr">
            <p className="location">About AIGIN Group</p>
            <p className="description">
              AIGIN Group takes pride in delivering projects that showcase what
              innovation, dedication, and quality can achieve in the real estate
              sector. Guided by the philosophy of continuous improvement, the
              group focuses on delighting customers through timely delivery and
              uncompromised quality. With a foundation built on the 7 Cs of
              excellence—Competence, Capability, Comprehensive, Credibility,
              Cost-Effectiveness, Consistency, and Confidence—AIGIN Group has
              earned a reputation for customer satisfaction. Although a young
              company, it has established a strong presence across multiple real
              estate segments, with a vision to create long-term value and set
              benchmarks in Indian real estate in the years to come.
            </p>
          </div>
        </div>

        {/*-
        <div className="project-highlights">
          <h2>Project Highlights</h2>
          <ul>
            <li>Fully Equipped Gym</li>
            <li>Senior Citizens’ Pavilion</li>
            <li>
            Jogging/Walking Track
            </li>
            <li>CCTV Surveillance</li>
            <li>Swimming Pool</li>
            <li>⁠Badminton Court</li>

            <li>Kids Play Area</li>
            <li>
            Flower Garden
            </li>
            <li>
            Salon/Spa
            </li>
            <li>
            24X7 Security
            </li>
            <li>Multipurpose Hall</li>
            <li>Pharmacy</li>
          </ul>
        </div>
        -*/}
      </section>

      <Modal
        isOpen={brochureModalIsOpen}
        onRequestClose={closeBrochureModal}
        contentLabel="Brochure Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeBrochureModal}>
          ×
        </button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back </p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">AIGIN ROYAL</h2>
            <p className="modal-sub-heading">At Sector 1, Greater Noida West</p>
            <form className="modal-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => validateName(e.target.value)}
                  required
                />
                {nameError && <p className="error">{nameError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => validateEmail(e.target.value)}
                  required
                />
                {emailError && <p className="error">{emailError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={mobile}
                  onChange={(e) => validateMobile(e.target.value)}
                  required
                />
                {mobileError && <p className="error">{mobileError}</p>}
              </div>
              <div className="butt-f">
                <button
                  className="submit-button-f"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Click To Download"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <section id="price" className="price-section-main">
        <div className="price-head-div">
          <h1 className="head">Pricing</h1>
        </div>
        <div className="price-section">
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Saleable Area</th>
                <th>Final Price</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {/* Data for 3 BHK */}
              <tr>
                <td>DUPLEX </td>
                <td> 4025 sq.ft.</td>
                <td>On Request *</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
              <tr>
                <td>3 BHK </td>
                <td>1825 sq.ft.</td>
                <td>On Request *</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
              {/* Data for 4 BHK */}
              <tr>
                <td>3 BHK</td>
                <td>1745 sq.ft.</td>
                <td>On Request*</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>

              <tr>
                <td>2 BHK</td>
                <td>1836 sq.ft.</td>
                <td>On Request*</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="div-price-image">
            <a className="anc" onClick={openEnquiryModal}>
              <div className="darksoul-card2">
                <div className="circle2" />
                <img
                  src="rupi.webp"
                  alt="Dark"
                  width={49}
                  height={60}
                  style={{ zIndex: 0 }}
                />
                <p className="content">Know Price</p>
              </div>
            </a>
          </div>
        </div>
      </section>
      <Modal
        isOpen={detailsModalIsOpen}
        onRequestClose={closeDetailsModal}
        contentLabel="Details Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeDetailsModal}>
          ×
        </button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back </p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">AIGIN ROYAL</h2>
            <p className="modal-sub-heading">At Sector 1, Greater Noida West</p>
            <form className="modal-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => validateName(e.target.value)}
                  required
                />
                {nameError && <p className="error">{nameError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => validateEmail(e.target.value)}
                  required
                />
                {emailError && <p className="error">{emailError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={mobile}
                  onChange={(e) => validateMobile(e.target.value)}
                  required
                />
                {mobileError && <p className="error">{mobileError}</p>}
              </div>
              <div className="butt-f">
                <button
                  className="submit-button-f"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Get Price Details"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <section id="site&floor" className="sfp-section-main">
        <div className="sfp-head-div">
          <h1 className="head">Site Map & Floor Layout</h1>
        </div>
        <div className="site-container">
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s1.webp" alt="Image-31" className="image" />
            <div className="overlay">
              Enquire Now: 3BHK -2ND TO 18TH FLOOR , UNIT - 3&4 ,TOWER-1
            </div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s2.webp" alt="Image-22" className="image" />
            <div className="overlay">
              Enquire Now: 3BHK - 2ND TO 18TH FLOOR,UNIT -1 & 2, TOWER-1
            </div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s3.webp" alt="Image-33" className="image" />
            <div className="overlay">
              Enquire Now For 3BHK - 19TH FLOOR,UNIT - 4 ,TOWER-1
            </div>
          </div>
        </div>
        <div className="site-container2">
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s4.webp" alt="Image-11" className="image" />
            <div className="overlay">
              Enquire Now: 3BHK - 19TH FLOOR,UNIT - 1 ,TOWER-1
            </div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s5.webp" alt="Image-2" className="image" />
            <div className="overlay">
              Enquire Now: 3BHK - 1ST FLOOR,UNIT - 3, TOWER-2
            </div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s6.webp" alt="Image-3" className="image" />
            <div className="overlay">
              Enquire Now: 2BHK - 19TH FLOOR,UNIT - 4, TOWER-2
            </div>
          </div>
        </div>
        <div className="site-container2">
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s7.webp" alt="Image-11" className="image" />
            <div className="overlay">
              Enquire Now: 3BHK - 19TH FLOOR,UNIT 1 ,TOWER-2
            </div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s8.webp" alt="Image-2" className="image" />
            <div className="overlay">
              Enquire Now: 3BHK - 1ST FLOOR,UNIT - 1 & 2, TOWER-2
            </div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s9.webp" alt="Image-3" className="image" />
            <div className="overlay">
              Enquire Now: 3BHK -2ND TO 18TH FLOOR,UNIT - 1, 2 & 3, TOWER-2
            </div>
          </div>
        </div>
        <div className="site-container2">
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s10.webp" alt="Image-11" className="image" />
            <div className="overlay">
              Enquire Now:DUPLEX LOWER - 1ST FLOOR,UNIT -4 ,TOWER-2
            </div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s11.webp" alt="Image-2" className="image" />
            <div className="overlay">
              Enquire Now: 3rd, 5th, 7th, 9th, 11th, 13th, 15th & 17th
              FLOOR,UNIT-4, TOWER-2
            </div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="/s12.webp" alt="Image-3" className="image" />
            <div className="overlay">
              Enquire Now: 2nd, 4th, 6th, 8th, 10th, 12th, 14th, 16th & 18th
              FLOOR,UNIT-4, TOWER-2
            </div>
          </div>
        </div>
      </section>
      <section id="amenities" className="amenities-section-main">
        <div className="amen-head-div">
          <h1 className="head">Facilities</h1>
        </div>
        <div className="amenities-section">
          <div className="amenities-car">
            <div
              id="carouselExampleFade"
              className="carousel slide carousel-fade"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div className="div-car">
                    <ul>
                      <li>Swimming Pool</li>
                      <li>Gymnasium</li>
                      <li>Club House</li>
                    </ul>
                    <ul>
                      <li>Creche/Day Care</li>
                      <li>Children's Play Area</li>
                      <li>Park</li>
                    </ul>
                  </div>
                </div>

                <div className="carousel-item">
                  <div className="div-car">
                    <ul>
                      <li>Banquet Hall</li>
                      <li>Gazebo</li>
                      <li>Jogging Track</li>
                    </ul>
                    <ul>
                      <li>CCTV Surveillance</li>
                      <li>Ample Parking Area</li>
                      <li>Security Cabin</li>
                    </ul>
                  </div>
                </div>
              </div>

              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleFade"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleFade"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
        <img src="am.webp" className="am-img" alt="amenities" />
      </section>
      <section id="gallery" className="gallery-section-main">
        <div className="gal-head-div">
          <h1 className="head">Visual Showcase</h1>
        </div>
        <div className="gallery-section">
          <div className="App1">
            <div className="image-grid">
              {images.map((image, index) => (
                <div key={index} className="image-container">
                  <img
                    src={image}
                    alt={`img-${index}`}
                    onClick={() => openModal(image)}
                  />
                </div>
              ))}
            </div>

            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              contentLabel="Image Modal"
              className="Modal"
              overlayClassName="Overlay"
            >
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
              {selectedImage && (
                <img className="modal-img" src={selectedImage} alt="Selected" />
              )}
            </Modal>
          </div>
        </div>
      </section>
      <section id="location" className="location-section">
        <div className="lo-head-div">
          <h1 className="head">Our Location</h1>
        </div>
        <div className="location-main">
          <div className="responsive-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.481408050378!2d77.44094747374884!3d28.555303387586626!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cefabd8da6fb1%3A0x41fc0afb9131a9ab!2sAigin%20Royal%20%7C%20Aig%20Royal!5e0!3m2!1sen!2sin!4v1757318537062!5m2!1sen!2sin"
              width={600}
              height={450}
              frameBorder={0}
              style={{ border: 0 }}
              allowFullScreen
            />
          </div>
        </div>
        {/*-
        <div className="loc-detail">
          <div className="loc-div1">
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 25 Mins. - Noida International Airport</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 5 Mins. - Patanjali</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 5 Mins. - Cricket Stadium</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 15 Mins. - Vivo</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 15 Mins. - Film City</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 15 Mins. - Oppo</p>
            </div>
          </div>
        </div>
        -*/}
      </section>

      <section id="virtualsitetour" className="video-section-main">
        <div className="video-head-div">
          <h1 className="head">Virtual Site Visit</h1>
        </div>
        <div className="two-virtu">
          <div className="video-section">
            <div className="video-container">
              <img className="tour-img" src="/ap.webp" alt="tour" />

              <>
                <div className="overlay-text">
                  <h1 className="over-text0">APARTMENT VIEW</h1>
                  <p>AIGIN Royal - At Sector 1, Greater Noida West</p>
                </div>

                <button className="play-button" onClick={openEnquiryModal}>
                  <FaRegCirclePlay className="logo-vi" />
                </button>
              </>
            </div>
          </div>
          <div className="video-section">
            <div className="video-container">
              <img className="tour-img" src="/siite2.webp" alt="tour2" />

              <>
                <div className="overlay-text">
                  <h1 className="over-text0">VIRTUAL SITE VISIT</h1>
                  <p>AIGIN Royal - At Sector 1, Greater Noida West</p>
                </div>

                <button className="play-button" onClick={openEnquiryModal}>
                  <FaRegCirclePlay className="logo-vi" />
                </button>
              </>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
